var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2414 31.3086C32.0145 30.5408 33.2537 30.5408 34.0267 31.3086L39.136 35.4328H39.2247C40.2584 36.4776 40.2584 38.1716 39.2247 39.2164C38.1911 40.2612 36.5151 40.2612 35.4814 39.2164L31.2414 34.3569L31.0805 34.1754C30.7808 33.796 30.6153 33.323 30.6153 32.8327C30.6153 32.2608 30.8406 31.7123 31.2414 31.3086ZM17.1553 0C21.7051 0 26.0687 1.82687 29.2859 5.07873C32.5031 8.33058 34.3106 12.741 34.3106 17.3399C34.3106 26.9164 26.6299 34.6797 17.1553 34.6797C7.68068 34.6797 0 26.9164 0 17.3399C0 7.76332 7.68068 0 17.1553 0Z",
    fill: "#08296B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilled);
export default __webpack_public_path__ + "static/media/search-filled.5b2bfc286ffad5e00d08cf0f5cf3fbf3.svg";
export { ForwardRef as ReactComponent };